import React from 'react'
import { Link } from 'react-router-dom'
import Paragraph from '../../scentregroup-ui/components/paragraph'
import { HOME } from '../paths'
import style from './index.module.scss'

const NotFoundPage: React.FC = () => (
  <div className={style.wrapper}>
    <Paragraph>404 Not Found</Paragraph>

    <Paragraph>
      <Link to={HOME} className={style.homeLink}>
        Take me home
      </Link>
    </Paragraph>
  </div>
)

export default NotFoundPage
